import { PropsWithChildren, ReactNode } from "react";

import Footer from "../components/Footer";

const BaseLayout = ({ children }: PropsWithChildren) => (
  <div id="root">
    {children}
    <Footer />
  </div>
);

export default BaseLayout;
